<template>
  <modal
    name="mEdit"
    height="auto"
    width="900"
    :scrollable="true"
    @before-open="loadClientes()"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <SeletorClientesAvancado
      :visible="seletorClientesVisible"
      @close="seletorClientesVisible = false"
      @confirm="onSelecaoAvancadaClientes"
    />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab>
            <template slot="title">
              Dados do Usuário
              <span v-if="dadosUsuarioPendente" class="tab-badge-pendente">{{ dadosUsuarioPendente }}</span>
            </template>
            <div v-if="+item.aguardando === 1 && (isLeadNaoCliente || isLeadClienteSemAcesso)" class="config-section dados-empresa-lead">
              <div class="config-section__header">
                <span class="config-section__icone"><fa-icon icon="building" /></span>
                <div>
                  <div class="config-section__title">Dados da empresa</div>
                  <div class="config-section__descricao">Dados cadastrais informados pelo solicitante, disponíveis apenas para consulta.</div>
                </div>
              </div>
              <table class="table table-sm config-tabela">
                <thead>
                  <tr>
                    <th v-for="campo in dadosEmpresaLead" :key="campo.label" scope="col">{{ campo.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="hasDadosEmpresaLead">
                    <td v-for="campo in dadosEmpresaLead" :key="campo.label">
                      <span v-if="campo.valor">{{ campo.valor }}</span>
                      <span v-else class="config-tabela__nao-informado">
                        Não informado
                      </span>
                    </td>
                  </tr>
                  <tr v-else>
                    <td :colspan="dadosEmpresaLead.length" class="text-center">
                      <span class="config-tabela__nao-informado">
                        Dados não informados
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="xrow">
              <div class="col-2-3">
                <div class="form-group">
                  <label>Nome <span class="text-danger">*</span></label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.nome"
                  />
                  <div class="message">
                    {{ validation.firstError("item.nome") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Ativo <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="item.ativo">
                    <option value>-</option>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("item.ativo") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>CPF ou CNPJ (opcional)</label>
                  <!-- X = alfanumérico (vue-the-mask): CNPJ pode ter letras nas
                       12 primeiras posições (IN RFB 2229/2024); DVs numéricos -->
                  <TheMask
                    :mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                    class="form-control"
                    v-model="item.cpf"
                  />
                  <div class="message">
                    {{ validation.firstError("item.cpf") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>E-mail <span class="text-danger">*</span></label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.email"
                  />
                  <div class="message">
                    {{ validation.firstError("item.email") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Telefone</label>
                  <TheMask
                    mask="(##) #########"
                    class="form-control"
                    autocomplete="off"
                    v-model="item.tel"
                  />
                  <div class="message">
                    {{ validation.firstError("item.tel") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Data Nascimento (opcional)</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.dtNasc"
                    type="date"
                  />
                  <div class="message">
                    {{ validation.firstError("item.dtNasc") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Senha</label>
                  <input
                    class="form-control"
                    autocomplete="off"
                    v-model="item.senha"
                    type="text"
                  />
                  <div class="message">
                    {{ validation.firstError("item.senha") }}
                  </div>
                </div>
              </div>
              <div
                class="col-1-3"
                v-show="item.visualizaValidade || exibeValidaCarga"
              >
                <div class="form-group">
                  <label>Validade da Carga (Dias)</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.diasValidadeCarga"
                    type="number"
                  />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('forcarTrocaSenha')"
              >
                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="item.forcarTrocaSenha" />
                    Exigir troca de senha no próximo acesso
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Tipo <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="item.tipoId"
                    v-on:change="cleanUnusedFields"
                  >
                    <option value>-</option>
                    <option
                      v-for="i in tipos"
                      v-bind:value="i.id"
                      v-bind:key="i.id"
                    >
                      {{ i.desc }}
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("item.tipoId") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Perfil <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="item.perfil">
                    <option value>-</option>
                    <option
                      v-for="i in perfisPossiveis"
                      v-bind:value="i.id"
                      v-bind:key="i.id"
                    >
                      {{ i.descricao }}
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("item.perfil") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('apiToken')">
                <div class="form-group">
                  <label>
                    Api Token
                    <a
                      class="token-generator"
                      href="#"
                      v-on:click="generateToken()"
                    >
                      Gerar token
                    </a>
                  </label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.apiToken"
                    type="text"
                  />
                  <div class="message">
                    {{ validation.firstError("item.apiToken") }}
                  </div>
                </div>
              </div>
              <div class="col-1-1" v-show="validaTokenFirebase()">
                <label>Token Firebase:</label>
                <input
                  class="form-control w-100"
                  autocomplete="chrome-off"
                  v-model="item.firebaseToken"
                  readonly
                  type="text"
                />
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-3"
                v-show="inputShouldBeVisible('orcamentosParados')"
              >
                <div class="form-group">
                  <label>Número de Orçamentos Sem Enviar</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.orcamentosParados"
                    type="number"
                  />
                  <div class="message">
                    {{ validation.firstError("item.orcamentosParados") }}
                  </div>
                </div>
              </div>
              <div
                class="col-1-3"
                v-show="inputShouldBeVisible('percMaxNegociacao')"
              >
                <div class="form-group">
                  <label>Perc. máx. aprovar negociação</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.percMaxNegociacao"
                    type="number"
                  />
                  <div class="message">
                    {{ validation.firstError("item.percMaxNegociacao") }}
                  </div>
                </div>
              </div>
              <div
                class="col-1-3"
                v-show="inputShouldBeVisible('visualizaSetor')"
              >
                <div class="form-group">
                  <label for="">Setor Atendimento</label>
                  <select
                    class="form-control"
                    v-model="item.setor_atendimento_id"
                  >
                    <option
                      v-for="setor in setores"
                      v-bind:key="setor.id"
                      :value="setor.id"
                    >
                      {{ setor.desc }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-1-3"
                v-show="inputShouldBeVisible('visualizaExpediente')"
              >
                <div class="form-group">
                  <label for="">Expediente p/ Login</label>
                  <select class="form-control" v-model="item.expedienteId">
                    <option :value="null">-</option>
                    <option
                      v-for="expediente in expedientes"
                      v-bind:key="expediente.id"
                      :value="expediente.id"
                    >
                      {{ expediente.desc }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-3" v-show="inputShouldBeVisible('matErp')">
                <div class="form-group">
                  <label>Matrícula ERP</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.matErp"
                    type="text"
                  />
                  <div class="message">
                    {{ validation.firstError("item.matErp") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('ramal')">
                <div class="form-group">
                  <label>Ramal</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.ramal"
                    type="text"
                  />
                  <div class="message">
                    {{ validation.firstError("item.ramal") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('sip_usuario')">
                <div class="form-group">
                  <label>Usuário SIP (Verso Phone)</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.sip_usuario"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('sip_senha')">
                <div class="form-group">
                  <label>Senha SIP</label>
                  <input
                    class="form-control"
                    autocomplete="new-password"
                    v-model="item.sip_senha"
                    type="password"
                    placeholder="Deixe em branco para manter a atual"
                  />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-1" v-show="inputShouldBeVisible('codOp')">
                <div class="xrow">
                  <div class="form-group">
                    <div class="col-1-4">
                      <label>Cód. Operador</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codOp"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codOp") }}
                      </div>
                    </div>
                    <div class="col-1-4">
                      <label>Cód. Operador 2</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codOp2"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codOp2") }}
                      </div>
                    </div>
                    <template v-if="item.preferencias">
                      <div
                        class="col-1-4"
                        v-show="
                          inputShouldBeVisible('permiteVendaForaCarteira')
                        "
                      >
                        <label>Permite venda fora da carteira</label>
                        <select
                          class="form-control"
                          v-model="
                            item.preferencias.permite_venda_fora_carteira
                          "
                        >
                          <option :value="null">Usar do parâmetro geral</option>
                          <option :value="1">Sim</option>
                          <option :value="0">Não</option>
                        </select>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-1-1" v-show="inputShouldBeVisible('codRca')">
                <hr />
                <div class="xrow">
                  <div class="form-group">
                    <div class="col-1-4">
                      <label>Cód. RCA</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codRca"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codRca") }}
                      </div>
                    </div>
                    <div class="col-1-4">
                      <label>Cód. RCA 2</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codRca2"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codRca2") }}
                      </div>
                    </div>
                    <div
                      class="col-1-4"
                      v-show="inputShouldBeVisible('usaContaCorrente')"
                    >
                      <label>Usa Conta Corrente</label>
                      <select
                        class="form-control"
                        v-model="item.usaContaCorrente"
                      >
                        <option :value="null">Usar do parâmetro geral</option>
                        <option :value="1">Sim</option>
                        <option :value="0">Não</option>
                      </select>
                    </div>
                    <div
                      class="col-1-4"
                      v-show="inputShouldBeVisible('permiteNegociar')"
                    >
                      <label>Permite Negociação</label>
                      <select
                        class="form-control"
                        v-model="item.permiteNegociar"
                      >
                        <option :value="null">Usar do parâmetro geral</option>
                        <option :value="1">Sim</option>
                        <option :value="0">Não</option>
                      </select>
                    </div>
                  </div>
                </div>
                <hr />
                <div v-if="isRepresentante">
                  <div class="xrow">
                    <div class="form-group">
                      <div class="col-1-3">
                        <label>
                          <span>Usa atendimento (Check-in/Check-out)</span>
                        </label>
                        <select
                          class="form-control"
                          v-model="item.usaCheckinCheckout"
                        >
                          <option :value="null">Usar do parâmetro geral</option>
                          <option :value="1">Sim</option>
                          <option :value="0">Não</option>
                        </select>
                      </div>
                      <div v-if="isRepresentante" class="col-1-2">
                        <label>
                          <span>Quem pode criar agenda de visita?</span>
                        </label>
                        <select
                          class="form-control"
                          v-model="item.permiteCriarAgenda"
                        >
                          <option :value="null">Usar do parâmetro geral</option>
                          <option value="REPRESENTANTE">Somente o usuário</option>
                          <option value="SUPERIORES">Somente superiores</option>
                          <option value="REPRESENTANTE_SUPERIORES">Usuário e superiores</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('codSuperv')">
                <div class="xrow">
                  <div class="form-group">
                    <div class="col-1-2">
                      <label>Cód. Superv.</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codSuperv"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codSuperv") }}
                      </div>
                    </div>
                    <div class="col-1-2">
                      <label>Cód. Superv. 2</label>
                      <input
                        class="form-control"
                        autocomplete="chrome-off"
                        v-model="item.codSuperv2"
                        type="text"
                      />
                      <div class="message">
                        {{ validation.firstError("item.codSuperv2") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1-3" v-show="inputShouldBeVisible('codGer')">
                <div class="form-group">
                  <label>Cód. Gerente</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    v-model="item.codGer"
                    type="text"
                  />
                  <div class="message">
                    {{ validation.firstError("item.codGer") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-1" v-show="inputShouldBeVisible('assumePed')">
                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="item.assumePed" />
                    Assumir pedidos (os pedidos enviados pelo colaborador
                    receberão o cód. do vendedor como emitente do pedido)
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('registraAtendimentoCliente')"
              >
                <div class="form-group" v-if="item.preferencias">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.preferencias.registra_atendimento_cliente"
                    />
                    Solicita registro de atendimento ao fechar tela do cliente
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('registraAtendimentoOrcamento')"
              >
                <div class="form-group" v-if="item.preferencias">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.preferencias.registra_atendimento_orcamento"
                    />
                    Solicita registro de atendimento ao fechar tela de orçamento
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('reagendaOrcamento')"
              >
                <div class="form-group" v-if="item.preferencias">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.preferencias.reagenda_orcamento"
                    />
                    Solicita o reagendamento do atendimento ao fechar tela de
                    orçamento
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('importaBackups')"
              >
                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="item.importaBackups" />
                    Permite que o usuário importe backups de seus orçamentos no
                    App VersoVendas
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div
                class="col-1-1"
                v-show="inputShouldBeVisible('visualizaSomenteCarteira')"
              >
                <div class="form-group">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.visualizaSomenteCarteira"
                    />
                    <span v-if="getTipoColaborador() === 'OPERADOR'">
                      Visualiza somente clientes da carteira</span
                    >
                    <span v-else>
                      Visualiza apenas rcas e clientes da carteira</span
                    >
                  </label>
                </div>
              </div>
            </div>
            <div
              class="xrow"
              v-if="
                isOperadorOrRepresentante &&
                inputShouldBeVisible('usaRestricaoSegmentoVendaSupervisor')
              "
            >
              <div class="col-1-1">
                <div class="form-group">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.usaRestricaoSegmentoVendaSupervisor"
                    />
                    Utiliza restrições de segmento de venda do supervisor
                  </label>
                </div>
              </div>
            </div>
            <div
              class="xrow"
              v-show="
                inputShouldBeVisible('utilizaSaldoContaCorrenteOutroVendedor')
              "
            >
              <div class="col-1-1">
                <div class="form-group">
                  <label>
                    <input
                      type="checkbox"
                      v-model="item.utilizaSaldoContaCorrenteOutroVendedor"
                    />
                    Permite utilizar saldo da conta corrente de outros
                    vendedores (regra utilizada para venda com cliente fora da
                    carteira)
                  </label>
                </div>
              </div>
            </div>
          </CTab>
          <CTab title="Clientes ( B2B )" v-if="item.id">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px">
              <button
                type="button"
                class="button button-primary"
                style="height: 36px; padding: 0 16px; white-space: nowrap"
                v-on:click="seletorClientesVisible = true"
              >
                <fa-icon icon="search" /> Seleção avançada de clientes
              </button>
              <small class="text-muted">
                Vincule muitos clientes de uma vez por filtro ou consulta.
              </small>
            </div>
            <div class="xrow">
              <div class="col-1-1">
                <div class="col-1-2">
                  <span class="clientes filters__search">
                    <input
                      type="text"
                      v-model="filter"
                      v-on:input="debounceLoadClientes()"
                      placeholder="Filtrar por id, cnpj ou razão social"
                    />
                    <img
                      src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
                    />
                  </span>
                </div>
              </div>
              <div class="col-1-2">
                <div class="scrollable lista-clientes" style="height: 600px">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th colspan="3">Clientes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cliente in clientes" v-bind:key="cliente.id">
                          <td colspan="3">
                            <div class="line">
                              <div>
                                <span class="pre-text"
                                  >ID: {{ cliente.id }}&nbsp;-&nbsp; CNPJ:
                                  {{ cliente.cnpj }}</span
                                >
                                <div class="main-text">
                                  {{ cliente.razSoc }}
                                </div>
                              </div>
                              <div class="actions">
                                <button
                                  v-on:click="addCliente(item.id, cliente.id)"
                                  class="button button-success"
                                  :disabled="clienteJaAdicionado(cliente.id)"
                                >
                                  <svg
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 42 42"
                                    style="
                                      width: 12px;
                                      height: 12px;
                                      fill: rgb(255, 255, 255);
                                    "
                                  >
                                    <path
                                      d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-1-2">
                <div class="scrollable lista-clientes" style="height: 600px">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th colspan="3">Clientes Vinculados</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="cliente in item.clientes"
                          v-bind:key="cliente.id"
                        >
                          <td colspan="3">
                            <div class="line">
                              <div>
                                <span class="pre-text"
                                  >ID: {{ cliente.id }}</span
                                >
                                <h6 class="main-text">{{ cliente.razSoc }}</h6>
                              </div>
                              <span class="actions">
                                <button
                                  type="button"
                                  name="button"
                                  v-on:click="remCliente(item.id, cliente.id)"
                                  class="button button-error"
                                >
                                  <fa-icon icon="trash-alt" />
                                </button>
                              </span>
                            </div>
                            <div class="details">
                              <DetalhesCliente :cliente="cliente" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </CTab>
          <CTab
            v-if="isClienteB2b && item.id && !findSubClientePerfil && (!usaFluxoLiberacaoClienteLead || isLeadClienteSemAcesso)"
            title="Segmentos"
          >
            <Segmentos
              :colaboradorId="item.id"
              :segmentos="listaSegmentos"
              :dimensoesRestritas="dimensoesRestritas"
              :usaRestricaoCompra="usaRestricaoCompra"
              @usa-restricao="isUsaRestricaoAtivo"
              :limpaDimensoes="limpaDimensoes"
              :liberarDimensoes="liberarDimensoes"
            />
          </CTab>
          <CTab
            v-if="isClienteB2b && item.id && !findSubClientePerfil && (!usaFluxoLiberacaoClienteLead || isLeadClienteSemAcesso)"
            title="Mix de Produtos"
          >
            <MixProdutos
              :produtosRestritos="produtosRestritos"
              :usaRestricaoCompra="usaRestricaoCompra"
              @usa-restricao="isUsaRestricaoAtivo"
              @produtos-importados="atualizarProdutosImportados"
              @atualizar-produtos-restritos="atualizarProdutosRestritos"
            />
          </CTab>
          <CTab v-if="usaRestricaoSegmento" title="Segmentos Bloqueados">
            <SegmentoVendaDimensoes
              :colaborador="item"
              :items="dimensoesSegmentoVenda"
              :upInsertDimensao="upInsertDimensao"
              :dimensoesBloqueadasSegmentoVenda="
                dimensoesBloqueadasSegmentoVenda
              "
              :insertAllDimensao="insertAllDimensao"
              :deleteAllDimensao="deleteAllDimensao"
              :key="componentSegmentoVendaDimensoes"
              :parametros="parametros"
            />
          </CTab>
          <CTab v-if="usaRestricaoSegmento" title="Clientes Exceção">
            <SegmentoVendaClientes
              :colaborador="item"
              :items="clientesSegmentoVenda"
              :paginator="clientesSegmentoVendaPaginator"
              :termoInicial="filtroClientesSegmento"
              :upInsertClienteExcecao="upInsertClienteExcecao"
              :insertAllClientes="insertAllClientes"
              :deleteAllClientes="deleteAllClientes"
              :onBuscar="buscarClientesSegmento"
              :onTrocarPagina="trocarPaginaClientesSegmento"
              :key="componentSegmentoVendaClientes"
              :parametros="parametros"
            />
          </CTab>
          <CTab v-if="item.id" title="Licenciamento">
            <Licenciamento :item="item" :licencas="licencasDisponiveis" :licencasModulos="licencasModuloDisponiveis"/>
          </CTab>
          <CTab
            v-if="isFuncionarioOuAtendente && !ocultaAbasNoAguardando"
            title="Filiais (SAC)"
          >
            <FiliaisSac :colaboradorId="item.id" />
          </CTab>
          <CTab v-if="+item.aguardando === 1 && isLeadNaoCliente">
            <template slot="title">
              Configurações de Compra
              <span v-if="liberarFormPendente" class="tab-badge-pendente">{{ liberarFormPendente }}</span>
            </template>
            <div class="alert remover" v-show="!!errorMessageLiberar">
              <a href="#" class="close" @click="errorMessageLiberar = null">&times;</a>
              {{ errorMessageLiberar }}
            </div>

            <div class="config-section">
              <div class="config-section__header">
                <span class="config-section__icone"><fa-icon icon="user-tie" /></span>
                <div>
                  <div class="config-section__title">Dados do vendedor</div>
                  <div class="config-section__descricao">Define o vendedor responsável, a filial e a tabela de preço atribuídos ao cliente.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Vendedor vinculado <span class="text-danger">*</span></label>
                    <select
                      v-model="liberarForm.vendedor_id"
                      class="form-control"
                      :disabled="loadingVendedoresLiberar"
                      @change="onVendedorLiberarChange"
                    >
                      <option value="">
                        {{ loadingVendedoresLiberar ? 'Carregando...' : 'Selecione um vendedor...' }}
                      </option>
                      <option v-for="v in vendedoresLiberar" :key="v.idColab" :value="v.idColab">{{ v.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Filial <span class="text-danger">*</span></label>
                    <select
                      v-model="liberarForm.filial_id"
                      class="form-control"
                      :disabled="!liberarForm.vendedor_id || loadingFiliaisLiberar"
                      @change="onFilialLiberarChange"
                    >
                      <option value="">
                        {{ loadingFiliaisLiberar ? 'Carregando...' : (!liberarForm.vendedor_id ? 'Aguardando vendedor...' : 'Selecione uma filial...') }}
                      </option>
                      <option v-for="f in filiaisLiberar" :key="f.id" :value="f.id">
                        {{ f.id }} - {{ f.fantasia || f.razaosocial }}
                      </option>
                    </select>
                    <div v-if="erroFilialLiberar" class="message">{{ erroFilialLiberar }}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Tabela de Preço <span class="text-danger">*</span></label>
                    <select
                      v-model="liberarForm.tabela_preco"
                      class="form-control"
                      :disabled="loadingTabelasPrecoLiberar"
                    >
                      <option value="">
                        {{ loadingTabelasPrecoLiberar ? 'Carregando...' : 'Selecione uma tabela...' }}
                      </option>
                      <option v-for="t in tabelasPrecoFiltradas" :key="t.numeroTabela" :value="t.numeroTabela">
                        {{ t.numeroTabela }} - {{ t.nomeTabela }}
                      </option>
                    </select>
                    <div v-if="erroTabelasPrecoLiberar" class="message">{{ erroTabelasPrecoLiberar }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="config-section mt-3">
              <div class="config-section__header">
                <span class="config-section__icone"><fa-icon icon="credit-card" /></span>
                <div>
                  <div class="config-section__title">Condições de pagamento</div>
                  <div class="config-section__descricao">Define as formas de pagamento habilitadas para o cliente e, a partir delas, a operação e o plano de pagamento padrão.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Cobrança Grupo <span class="text-danger">*</span></label>
                    <select
                      v-model="liberarForm.cobranca_grupo_id"
                      class="form-control"
                      :disabled="loadingCobrancasGrupoLiberar"
                    >
                      <option value="">
                        {{ loadingCobrancasGrupoLiberar ? 'Carregando...' : 'Selecione uma cobrança grupo...' }}
                      </option>
                      <option v-for="cg in gruposLiberar" :key="cg.grupo_id" :value="cg.id">
                        Grupo {{ cg.grupo_id }}
                      </option>
                    </select>
                    <div v-if="erroCobrancasGrupoLiberar" class="message">{{ erroCobrancasGrupoLiberar }}</div>
                  </div>
                </div>
                <div v-if="cobrancasDoGrupoLiberar.length" class="col-md-8">
                  <div class="form-group">
                    <label>Cobranças disponíveis para o grupo</label>
                    <table class="table table-sm config-tabela">
                      <thead>
                        <tr>
                          <th scope="col" class="cobrancas-grupo__codigo">Código</th>
                          <th scope="col">Descrição</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cobranca in cobrancasDoGrupoLiberar" :key="cobranca.id">
                          <td class="cobrancas-grupo__codigo">{{ cobranca.id }}</td>
                          <td>{{ cobranca.descricao }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <template v-if="+item.aguardando === 0">
        <CDropdown
          color="secondary"
          variant="outline"
          placement="top-start"
          toggler-text="Ações"
          v-if="item.id"
          style="margin-right: auto"
        >
          <CDropdownItem @click="desvincularDispositivos(item.id)">
            Desvincular Dispositivos
          </CDropdownItem>
        </CDropdown>
        <CButton variant="outline" color="secondary" @click="close">Fechar</CButton>
        <CButton
          color="primary"
          :disabled="validation.hasError()"
          @click="handleSubmit(false)"
        >
          {{ !!item.id ? "Alterar" : "Cadastrar" }}
        </CButton>
      </template>
      <template v-else>
        <CButton variant="outline" color="danger" @click="confirmarRejeitar" style="margin-right: auto">
          Rejeitar Cadastro
        </CButton>
        <CButton variant="outline" color="secondary" @click="close">Fechar</CButton>
        <CButton
          color="success"
          :disabled="loadingLiberarSubmit || !liberarFormValido"
          @click="submitLiberar"
        >
          <span v-if="loadingLiberarSubmit">Aguarde...</span>
          <span v-else>Liberar Colaborador</span>
        </CButton>
      </template>
    </div>
  </modal>
</template>
<script>
import { TheMask } from "vue-the-mask";
import { Validator } from "simple-vue-validator";
import { get, put, post } from "../../helpers/apiRequest";
import _filter from "lodash/filter";
import _some from "lodash/some";
import _debounce from "lodash/debounce";
import _find from "lodash/find";
import { uuid } from "vue-uuid";
import DetalhesCliente from "../Clientes/DetalhesCliente";
import CloseModal from "../../components/CloseModal";
import ShowHint from "@/components/ShowHint.vue";
import SegmentoVendaDimensoes from "./components/Dimensoes";
import SegmentoVendaClientes from "./components/Clientes";
import Licenciamento from "./components/Licenciamento";
import { isEmpty } from "lodash";
import Segmentos from "./components/Segmentos.vue";
import MixProdutos from "./components/MixProdutos.vue";
import FiliaisSac from "./components/FiliaisSac.vue";
import SeletorClientesAvancado from "./components/SeletorClientesAvancado";
import { isSubCliente, isEmail, isCpf, isCnpj, EMAIL_INVALID_MESSAGE } from "../../helpers/utils";

export default {
  name: "mEdit",
  components: {
    Segmentos,
    DetalhesCliente,
    TheMask,
    CloseModal,
    SegmentoVendaDimensoes,
    SegmentoVendaClientes,
    Licenciamento,
    MixProdutos,
    FiliaisSac,
    ShowHint,
    SeletorClientesAvancado,
  },
  props: [
    "update",
    "store",
    "remove",
    "close",
    "item",
    "perfis",
    "setores",
    "expedientes",
    "tipos",
    "addCliente",
    "remCliente",
    "parametros",
    "onLiberado",
  ],
  validators: {
    "item.nome": (value) => Validator.value(value).required('Preenchimento obrigatório'),
    "item.ativo": (value) => Validator.value(value).required('Preenchimento obrigatório'),
    "item.cpf": {
      validator(value) {
        return Validator.custom(() =>
          !value || isCpf(value) || isCnpj(value) ? false : "CPF/CNPJ Inválido"
        );
      },
    },
    "item.email": (value) =>
      Validator.value(value)
        .required('Preenchimento obrigatório')
        .custom(() => (!value || isEmail(value) ? false : EMAIL_INVALID_MESSAGE)),
    "item.perfil": (value) => Validator.value(value).required('Preenchimento obrigatório'),
    "item.tipoId": (value) => Validator.value(value).required('Preenchimento obrigatório'),
    "item.matErp": {
      validator(value) {
        return Validator.custom(() =>
          this.extraFieldValidator("matErp", value)
        );
      },
    },
    "item.codOp": {
      validator(value) {
        return Validator.custom(() => this.extraFieldValidator("codOp", value));
      },
    },
    "item.codRca": {
      validator(value) {
        return Validator.custom(() =>
          this.extraFieldValidator("codRca", value)
        );
      },
    },
    "item.ramal": {
      validator(value) {
        return Validator.custom(() => this.extraFieldValidator("ramal", value));
      },
    },
    "item.apiToken": {
      validator(value) {
        return Validator.custom(() =>
          this.extraFieldValidator("apiToken", value)
        );
      },
    },
  },
  data() {
    return {
      // Variáveis adicionadas para gerenciar restrição do tipo 'CLIENTE'
      usaRestricaoCompra: 0,
      listaSegmentos: [],
      dimensoesRestritas: [],
      produtosRestritos: [],

      isClienteB2b: false,

      seletorClientesVisible: false,

      filter: "",
      clientes: [],
      clientesSegmentoVenda: [],
      clientesSegmentoVendaPaginator: {},
      filtroClientesSegmento: "",
      dimensoesSegmentoVenda: [],
      dimensoesBloqueadasSegmentoVenda: [],
      licencasDisponiveis: [],
      licencasModuloDisponiveis: [],
      resultLimit: 100,
      activeTab: "dados",
      componentSegmentoVendaClientes: 0,
      componentSegmentoVendaDimensoes: 0,

      // Cascade form — aba Liberar
      liberarForm: {
        filial_id: '',
        tabela_preco: '',
        vendedor_id: '',
        cobranca_grupo_id: '',
      },
      vendedoresLiberar: [],
      filiaisLiberar: [],
      cobrancasGrupoLiberar: [],
      tabelasPrecoLiberar: [],
      loadingVendedoresLiberar: false,
      loadingFiliaisLiberar: false,
      loadingTabelasPrecoLiberar: false,
      loadingCobrancasGrupoLiberar: false,
      erroFilialLiberar: null,
      erroTabelasPrecoLiberar: null,
      erroCobrancasGrupoLiberar: null,
      loadingLiberarSubmit: false,
      errorMessageLiberar: null,
    };
  },
  computed: {
    findSubClientePerfil() {
      return isSubCliente(this.perfis, this.item.perfil);
    },
    perfisPossiveis() {
      return _filter(this.perfis, (p) => {
        return _some(p.perfisTipos, (tipo) => tipo === this.item.tipoId);
      });
    },
    usaRestricaoSegmento() {
      return (
        this.item.id &&
        (this.tipos[this.item.tipoId].chave === "OPERADOR" ||
          this.tipos[this.item.tipoId].chave === "SUPERVISOR" ||
          this.tipos[this.item.tipoId].chave === "REPRESENTANTE" ||
          this.tipos[this.item.tipoId].chave === "GERENTE")
      );
    },
    isOperadorOrRepresentante() {
      return (
        this.item.id &&
        (this.tipos[this.item.tipoId].chave === "OPERADOR" ||
          this.tipos[this.item.tipoId].chave === "REPRESENTANTE")
      );
    },
    isRepresentante() {
      return (
        this.item.id
          && (this.tipos[this.item.tipoId].chave === "REPRESENTANTE")
      );
    },
    isFuncionarioOuAtendente() {
      const tipo = this.tipos[this.item.tipoId];
      if (!tipo) return false;
      return tipo.chave === "FUNCIONARIO" || tipo.chave === "ATENDENTE";
    },
    tabelasPrecoFiltradas() {
      return this.tabelasPrecoLiberar;
    },
    usaFluxoLiberacaoClienteLead() {
      const parametroFluxoVenda = this.parametros.GERAL_CONFIGURACAO_FLUXO_LIBERACAO_CLIENTE_LEAD.padrao;

      return parametroFluxoVenda.tipo === 'ATIVO';
    },
    defaultsFluxoLiberacaoClienteLead() {
      const padrao = this.parametros.GERAL_CONFIGURACAO_FLUXO_LIBERACAO_CLIENTE_LEAD.padrao || {};

      return {
        vendedor_id:       padrao.colaborador_id_vendedor_padrao || '',
        filial_id:         padrao.filial_padrao_id || '',
        tabela_preco:      padrao.tabela_preco_padrao || '',
        cobranca_grupo_id: padrao.cobranca_grupo_padrao_id || '',
      };
    },
    // Deduplica por grupo_id: cada grupo aparece apenas uma vez no select, mesmo
    // que tenha múltiplas cobranças associadas. O value usa o id da primeira
    // cobranca_grupo encontrada para satisfazer o backend (que busca por id composto).
    gruposLiberar() {
      const mapa = new Map();
      for (const cg of this.cobrancasGrupoLiberar) {
        if (!mapa.has(cg.grupo_id)) {
          mapa.set(cg.grupo_id, cg);
        }
      }
      return Array.from(mapa.values());
    },
    grupoSelecionadoLiberar() {
      const selecionada = this.cobrancasGrupoLiberar.find(
        (cg) => cg.id === this.liberarForm.cobranca_grupo_id
      );

      return selecionada ? selecionada.grupo_id : null;
    },
    cobrancasDoGrupoLiberar() {
      if (!this.grupoSelecionadoLiberar) return [];

      return this.cobrancasGrupoLiberar
        .filter((cg) => cg.grupo_id === this.grupoSelecionadoLiberar)
        .map((cg) => ({
          id: cg.cobranca_id,
          descricao: (cg.cobranca && cg.cobranca.descricao) || cg.cobranca_id,
        }));
    },
    liberarFormValido() {
      if (!this.usaFluxoLiberacaoClienteLead) return true;
      return (
        this.liberarForm.filial_id &&
        this.liberarForm.vendedor_id &&
        this.liberarForm.cobranca_grupo_id &&
        this.liberarForm.tabela_preco
      );
    },
    isLeadClienteSemAcesso() {
      return this.item.statusCadastro === 'CLIENTE_SEM_ACESSO';
    },
    isLeadNaoCliente() {
      return this.item.statusCadastro === 'REVENDEDOR_LEAD';
    },
    dadosEmpresaLead() {
      const cliente  = (this.item.clientes || [])[0] || {};
      const cadastro = this.isLeadClienteSemAcesso
        ? { razaoSocial: cliente.razSoc, fantasia: cliente.fant, cidade: cliente.cid, uf: cliente.uf }
        : Array.isArray(this.item.cadastroLead)
          ? {}
          : this.item.cadastroLead || {};

      return [
        { label: 'Razão Social', valor: cadastro.razaoSocial },
        { label: 'Nome Fantasia', valor: cadastro.fantasia },
        { label: 'Cidade', valor: cadastro.cidade },
        { label: 'UF', valor: cadastro.uf },
      ];
    },
    hasDadosEmpresaLead() {
      return this.dadosEmpresaLead.some((campo) => campo.valor);
    },
    dadosUsuarioPendente() {
      return [this.item.nome, this.item.email, this.item.perfil, this.item.tipoId, this.item.ativo]
        .filter((f) => !f && f !== 0).length;
    },
    liberarFormPendente() {
      return [
        this.liberarForm.vendedor_id,
        this.liberarForm.filial_id,
        this.liberarForm.tabela_preco,
        this.liberarForm.cobranca_grupo_id,
      ].filter((f) => !f).length;
    },
    exibeValidaCarga() {
      if (typeof this.item.tipo !== "undefined") {
        const tipoUser = this.tipos[this.item.tipoId].chave;
        switch (tipoUser) {
          case "SUPERVISOR":
            return true;
            break;
          case "REPRESENTANTE":
            return true;
            break;
          case "ADMIN":
            return true;
            break;
          case "SUPERVISOR_CALLCENTER":
            return true;
            break;
          case "SUPERVISOR_FV_CALLCENTER":
            return true;
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    "item.id"(colaboradorId) {
      if (colaboradorId && this.usaRestricaoSegmento) {
        this.cargaSegmentoVenda(colaboradorId, false);
      }
      if (colaboradorId) {
        this.loadLicencasDisponiveis(colaboradorId);
      }
    },
    "item.tipoId"(tipoId) {
      this.limpaExpedienteNaoUtilizado();

      const tipoEncontrado = Object.values(this.tipos).find(
        (tipo) => tipo.chave === "CLIENTE"
      );

      if (tipoEncontrado && tipoEncontrado.id === tipoId) {
        this.loadSegmentos(this.item.id);
        return (this.isClienteB2b = true);
      }

      this.isClienteB2b = false;

      if (!this.isOperadorOrRepresentante) {
        this.item.usaRestricaoSegmentoVendaSupervisor = 0;
      }
    },
    item(colaborador) {
      this.usaRestricaoCompra = colaborador.usaRestricaoCompra;
      this.dimensoesRestritas = colaborador.dimensoesRestritas;
      this.produtosRestritos = colaborador.produtosRestritos;
      if (+colaborador.aguardando === 1 && colaborador.statusCadastro === 'REVENDEDOR_LEAD') {
        this.liberarForm = {
          filial_id: '',
          tabela_preco: '',
          vendedor_id: '',
          cobranca_grupo_id: '',
        };
        this.carregarDadosInicaisLiberar();
        this.$nextTick(() => this.$validate());
      }
    },
  },
  methods: {
    atualizarProdutosImportados(produtos) {
      this.produtosRestritos = produtos;
    },
    atualizarProdutosRestritos(produtosRestritos) {
      this.produtosRestritos = produtosRestritos;
    },
    isUsaRestricaoAtivo(novoValor) {
      this.usaRestricaoCompra = novoValor;
    },
    limpaDimensoes(dimensoes) {
      this.dimensoesRestritas = dimensoes;
    },
    liberarDimensoes(dimensoes) {
      this.dimensoesRestritas = [...this.dimensoesRestritas, ...dimensoes];
    },
    async loadSegmentos(colaboradorId) {
      try {
        const response = await get(
          `/admin/segmento-venda/dimensoes/${colaboradorId}`
        );

        this.listaSegmentos = response;
      } catch (error) {
        console.error("Erro ao carregar segmentos:", error);
      }
    },
    validaTokenFirebase() {
      return !isEmpty(this.item.firebaseToken);
    },
    clienteJaAdicionado(idCli) {
      return _find(this.item.clientes, { id: idCli });
    },
    getTipoColaborador() {
      return this.tipos[this.item?.tipoId]?.chave;
    },
    cleanUnusedFields(e) {
      this.item.perfil = null;
      this.item.matErp = null;
      this.item.codOp = null;
      this.item.codOp2 = null;
      this.item.codRca = null;
      this.item.codRca2 = null;
      this.item.codSuperv = null;
      this.item.codSuperv2 = null;
      this.item.codRca2 = null;
      this.item.usaContaCorrente = null;
      this.item.registraAtendimentoAgendaVisita = null;
      this.item.usaCheckinCheckout = null;
      this.item.permiteCriarAgenda = null;
      this.item.orcamentosParados = null;
      this.item.ramal = null;
      this.item.percMaxNegociacao = null;
      this.item.assumePed = null;
      this.item.apiToken = null;
      this.item.visualizaValidade = this.usaValidadeCarga();
    },
    extraFieldValidator(field, value) {
      // Matrícula, ramal, codOp e codRca são opcionais para qualquer tipo.
      if (["ramal", "codOp", "codRca", "matErp"].includes(field)) {
        return;
      }

      if (this.inputShouldBeVisible(field) && (!value || value.length <= 0)) {
        return "Required";
      }
    },
    loadClientes(page = 1, take = 15) {
      this.clientesSegmentoVenda = [];
      this.dimensoesSegmentoVenda = [];
      this.dimensoesBloqueadasSegmentoVenda = [];
      get(`/admin/clientes?page=${page}&take=${take}&q=${this.filter}`)
        .then((json) => {
          this.clientes = json.itens;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    onSelecaoAvancadaClientes({ ids }) {
      if (!this.item.id || !ids || !ids.length) {
        this.seletorClientesVisible = false;
        return;
      }
      this.loading = true;
      post(`/admin/colaboradores/${this.item.id}/clientes/lote`, {
        clientes: ids,
        modo: "adicionar",
      })
        .then((json) => {
          this.seletorClientesVisible = false;
          this.$swal({
            title: "Clientes vinculados",
            text: `${json.data.vinculados} novo(s) vínculo(s).`,
            icon: "success",
          });
          return get(`/admin/colaborador/${this.item.id}`);
        })
        .then((json) => {
          if (json && json.clientes) {
            this.item.clientes = json.clientes;
          }
        })
        .catch((err) =>
          this.$swal({ title: "Erro", text: err.message, icon: "error" })
        )
        .finally(() => (this.loading = false));
    },
    cargaSegmentoVenda(colaboradorId, showAlert = true) {
      this.reloadDimensoes();
      this.reloadClientes();

      if (showAlert) {
        this.$swal({
          title: "Carga realizada com sucesso",
          showCancelButton: false,
          cancelButtonText: "Fechar",
          showConfirmButton: true,
          icon: "success",
        });
      }
    },
    loadClientesSegmentoVenda(colaboradorId, page = 1) {
      const q = encodeURIComponent(this.filtroClientesSegmento || "");
      get(`/admin/segmento-venda/clientes/${colaboradorId}?page=${page}&take=20&q=${q}`)
        .then((json) => {
          this.clientesSegmentoVenda = json.itens || [];
          this.clientesSegmentoVendaPaginator = json.paginator || {};
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    buscarClientesSegmento(termo) {
      this.filtroClientesSegmento = termo;
      this.loadClientesSegmentoVenda(this.item.id, 1);
    },
    trocarPaginaClientesSegmento(page) {
      this.loadClientesSegmentoVenda(this.item.id, page);
    },
    upInsertClienteExcecao(colaboradorId, clienteId, status) {
      post(`/admin/segmento-venda/atualiza-cliente/`, {
        colaboradorId: colaboradorId,
        clienteId: clienteId,
        status: status,
      })
        .then((json) => {
          // this.$swal({
          //   title: 'Salvo com sucesso',
          //   text: json.message,
          //   showCancelButton: false,
          //   cancelButtonText: 'Fechar',
          //   showConfirmButton: true,
          //   icon: 'success',
          // });
        })
        .catch((error) => {
          // this.$swal({
          //   title: 'Falha ao Salvar',
          //   text: error.message,
          //   showCancelButton: true,
          //   cancelButtonText: 'Fechar',
          //   showConfirmButton: false,
          //   icon: 'error',
          // });
        });
      this.reloadClientes();
    },
    loadDimensoesSegmentoVenda(colaboradorId) {
      get(`/admin/segmento-venda/dimensoes/${colaboradorId}`)
        .then((json) => {
          this.dimensoesSegmentoVenda = json;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    upInsertDimensao(
      colaboradorId,
      dimensaoId,
      status,
      colunaDimensaoCategoria
    ) {
      post(`/admin/segmento-venda/atualiza-dimensao/`, {
        colaboradorId: colaboradorId,
        id: dimensaoId,
        status: status,
        coluna: colunaDimensaoCategoria,
      })
        .then((json) => {
          // this.$swal({
          //   title: 'Salvo com sucesso',
          //   text: json.message,
          //   showCancelButton: false,
          //   cancelButtonText: 'Fechar',
          //   showConfirmButton: true,
          //   icon: 'success',
          // });
        })
        .catch((error) => {
          // this.$swal({
          //   title: 'Falha ao Salvar',
          //   text: error.message,
          //   showCancelButton: true,
          //   cancelButtonText: 'Fechar',
          //   showConfirmButton: false,
          //   icon: 'error',
          // });
        });
      this.reloadDimensoes();
    },
    loadDimensoesBloqueadasSegmentoVenda(colaboradorId) {
      get(`/admin/segmento-venda/dimensoes-bloqueadas/${colaboradorId}`)
        .then((json) => {
          this.dimensoesBloqueadasSegmentoVenda = json;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    reloadDimensoes(remountComponent = null) {
      this.loadDimensoesSegmentoVenda(this.item.id);
      this.loadDimensoesBloqueadasSegmentoVenda(this.item.id);
      if (remountComponent) {
        this.componentSegmentoVendaDimensoes += 1;
      }
    },
    reloadClientes(remountComponent = null) {
      const page = this.clientesSegmentoVendaPaginator.current_page || 1;
      this.loadClientesSegmentoVenda(this.item.id, page);
      if (remountComponent) {
        this.componentSegmentoVendaClientes += 1;
      }
    },
    insertAllDimensao(dimensoesInsert) {
      put(`/admin/segmento-venda/check-all-dimensao/`, dimensoesInsert)
        .then((json) => {
          this.reloadDimensoes(true);
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    deleteAllDimensao(dimensoesDelete) {
      put(`/admin/segmento-venda/uncheck-all-dimensao/`, dimensoesDelete)
        .then((json) => {
          this.reloadDimensoes(true);
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    insertAllClientes(clientesInsert, colaboradorId) {
      put(
        `/admin/segmento-venda/${colaboradorId}/check-all-clientes/`,
        clientesInsert
      )
        .then((json) => {
          this.reloadClientes(true);
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    deleteAllClientes(clientesDelete, colaboradorId) {
      put(
        `/admin/segmento-venda/${colaboradorId}/uncheck-all-dimensao/`,
        clientesDelete
      )
        .then((json) => {
          this.reloadClientes(true);
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    debounceLoadClientes: _debounce(function () {
      this.loadClientes();
    }, 300),

    // ---- Aba Liberar ----
    async carregarDadosInicaisLiberar() {
      this.loadingVendedoresLiberar = true;
      this.loadingCobrancasGrupoLiberar = true;
      try {
        const [vendedores, cobrancasGrupo, tabelas] = await Promise.all([
          get('/admin/vendedores'),
          get('/admin/condicoes/cobranca-grupo?acessob2b=1&ativo=1'),
          get('/admin/tabelasprecos'),
        ]);

        this.vendedoresLiberar      = vendedores.itens || vendedores || [];
        this.cobrancasGrupoLiberar  = cobrancasGrupo.itens || cobrancasGrupo || [];
        this.tabelasPrecoLiberar    = tabelas || [];

        await this.aplicarDefaultsLiberar();
      } catch (e) {
        this.errorMessageLiberar = 'Erro ao carregar dados. Recarregue.';
      } finally {
        this.loadingVendedoresLiberar = false;
        this.loadingCobrancasGrupoLiberar = false;
      }
    },
    coerceDefault(raw) {
      if (raw === '' || raw === null || raw === undefined) return null;
      const asNumber = Number(raw);
      return Number.isFinite(asNumber) && String(asNumber) === String(raw).trim()
        ? asNumber
        : raw;
    },
    async aplicarDefaultsLiberar() {
      const defaults = this.defaultsFluxoLiberacaoClienteLead;

      const vendedorId = this.coerceDefault(defaults.vendedor_id);
      if (vendedorId !== null) {
        this.liberarForm.vendedor_id = vendedorId;
        await this.onVendedorLiberarChange();
      }

      const filialId = this.coerceDefault(defaults.filial_id);
      if (filialId !== null) {
        this.liberarForm.filial_id = filialId;
      }

      const tabelaPreco = this.coerceDefault(defaults.tabela_preco);
      if (tabelaPreco !== null) {
        this.liberarForm.tabela_preco = tabelaPreco;
      }

      const grupoIdPadrao = this.coerceDefault(defaults.cobranca_grupo_id);
      if (grupoIdPadrao !== null) {
        const grupoSelecionado = this.gruposLiberar.find(
          (g) => String(g.grupo_id) === String(grupoIdPadrao),
        );
        this.liberarForm.cobranca_grupo_id = grupoSelecionado ? grupoSelecionado.id : '';
      }
    },
    async onVendedorLiberarChange() {
      this.liberarForm.filial_id         = '';
      this.liberarForm.tabela_preco      = '';
      this.liberarForm.cobranca_grupo_id = '';
      this.filiaisLiberar                = [];
      this.erroFilialLiberar             = null;
      if (!this.liberarForm.vendedor_id) return;
      this.loadingFiliaisLiberar = true;
      try {
        const res             = await get(`/admin/filiais?colaborador_id=${this.liberarForm.vendedor_id}`);
        this.filiaisLiberar   = res.itens || res || [];
      } catch (e) {
        this.erroFilialLiberar = 'Erro ao carregar filiais.';
      } finally {
        this.loadingFiliaisLiberar = false;
      }
    },
    onFilialLiberarChange() {
      this.liberarForm.tabela_preco = '';
    },
    async submitLiberar() {
      if (!this.liberarFormValido) return;

      const isValid = await this.$validate();
      if (!isValid) return;

      this.loadingLiberarSubmit = true;
      this.errorMessageLiberar  = null;
      try {
        this.limpaExpedienteNaoUtilizado();

        let convertProdutosIds = [];
        if (this.produtosRestritos) {
          convertProdutosIds = this.produtosRestritos.map((p) => Number(p.value));
        }

        const colaboradorData = {
          ...this.item,
          dimensoesRestritas: this.dimensoesRestritas,
          produtosRestritos: convertProdutosIds,
          usa_restricao_compra: this.usaRestricaoCompra,
          preferencias: { ...this.item.preferencias },
        };

        await put(`/admin/colaboradores/${this.item.id}`, colaboradorData);
        await put(
          `/admin/colaboradores/${this.item.id}/liberar`,
          this.usaFluxoLiberacaoClienteLead ? this.liberarForm : {}
        );

        this.$swal({
          title: 'Colaborador liberado!',
          text: 'O colaborador foi liberado e receberá um e-mail de confirmação.',
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Fechar',
        });
        if (this.onLiberado) this.onLiberado();
      } catch (e) {
        this.$swal({
          title: 'Erro ao liberar',
          text: e.message || 'Erro ao liberar o colaborador.',
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Fechar',
        });
      } finally {
        this.loadingLiberarSubmit = false;
      }
    },
    async confirmarRejeitar() {
      const { isConfirmed, value: motivo } = await this.$swal({
        title: 'Rejeitar cadastro?',
        text: 'O colaborador será desativado e receberá um e-mail de notificação.',
        input: 'textarea',
        inputPlaceholder: 'Motivo (opcional)',
        inputAttributes: { maxlength: 500 },
        showCancelButton: true,
        confirmButtonText: 'Rejeitar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#e55353',
        icon: 'warning',
      });

      if (!isConfirmed) return;

      try {
        await put(`/admin/colaboradores/${this.item.id}/rejeitar`, { motivo: motivo || null });
        if (this.onLiberado) this.onLiberado();
      } catch (e) {
        this.$swal({
          title: 'Erro',
          text: e.message || 'Erro ao rejeitar o cadastro.',
          icon: 'error',
        });
      }
    },
    // ---- fim Aba Liberar ----

    handleSubmit(liberar) {
      this.limpaExpedienteNaoUtilizado();

      let convertProdutosIds = [];

      if (this.produtosRestritos) {
        convertProdutosIds = this.produtosRestritos.map((produto) =>
          Number(produto.value)
        );
      }

      let data = {
        ...this.item,
        dimensoesRestritas: this.dimensoesRestritas,
        produtosRestritos: convertProdutosIds,
        usa_restricao_compra: this.usaRestricaoCompra,
      };

      this.$validate().then((success) => {
        if (success) {
          let request;

          if (!!this.item.id) {
            request = this.update(liberar, 15, data);
          } else {
            request = this.store(data);
          }

          request.catch((error) => {
            this.$swal({
              title: "Ops!",
              text: error.message,
              icon: "error",
            });
          });
        }
      });
    },
    changeTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
      }
    },
    inputShouldBeVisible(inputName) {
      return (
        this.tipos[this.item.tipoId] &&
        this.tipos[this.item.tipoId].inputs.indexOf(inputName) >= 0
      );
    },
    limpaExpedienteNaoUtilizado() {
      if (
        this.tipos[this.item.tipoId] &&
        !this.inputShouldBeVisible("visualizaExpediente")
      ) {
        this.item.expedienteId = null;
      }
    },
    generateToken() {
      this.item.apiToken = uuid.v4();
    },
    loadLicencasDisponiveis(colaboradorId) {
      get(`/admin/licencas/${colaboradorId}`)
        .then((json) => {
          this.licencasDisponiveis = json.licencasSistema;
          this.licencasModuloDisponiveis = json.licencasModulo;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    usaValidadeCarga() {
      if (typeof this.tipos[this.item.tipoId].chave !== "undefined") {
        const tipoUser = this.tipos[this.item.tipoId].chave;
        switch (tipoUser) {
          case "SUPERVISOR":
            return true;
            break;
          case "REPRESENTANTE":
            return true;
            break;
          case "ADMIN":
            return true;
            break;
          case "SUPERVISOR_CALLCENTER":
            return true;
            break;
          case "SUPERVISOR_FV_CALLCENTER":
            return true;
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    desvincularDispositivos(colaboradorId) {
      put(`/admin/colaboradores/${colaboradorId}/desvincular-dispositivos`)
        .then((json) => {
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pre-text {
  font-size: 10px;
}

.main-text {
  font-size: 14px;
  font-weight: bold;
}

.details {
  background-color: #fafafa;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.config-section {
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 6px;
  padding: 16px;
}

.config-section__descricao {
  margin-top: 2px;
  font-size: 12px;
  color: #73818f;
}

.config-section__header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
}

.config-section__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 30%;
  background-color: #3c4b64;
  color: #fff;
  font-size: 15px;
  flex-shrink: 0;
}

.config-section__title {
  font-size: 13px;
  font-weight: 600;
  color: #3c4b64;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.config-readonly-field {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
}

.config-readonly-field__value {
  font-weight: 600;
  color: #2f353a;
}

.config-readonly-field__placeholder {
  color: #9da5b1;
  font-style: italic;
  font-size: 13px;
}

.dados-empresa-lead {
  margin-bottom: 16px;
}

.dados-empresa-lead .config-tabela th:nth-child(1) {
  width: 40%;
}

.dados-empresa-lead .config-tabela th:nth-child(2) {
  width: 25%;
}

.dados-empresa-lead .config-tabela th:nth-child(3) {
  width: 20%;
}

.dados-empresa-lead .config-tabela th:nth-child(4) {
  width: 15%;
}

.config-tabela {
  margin: 0;
  border-collapse: collapse;
  font-size: 13px;
  color: #3c4b64;
  background: #fff;
  border: 1px solid #d8dbe0;
}

.config-tabela th,
.config-tabela td {
  padding: 6px 10px;
  border-top: 1px solid #e4e7ea;
  vertical-align: middle;
}

.config-tabela thead th {
  border-top: none;
  border-bottom: 1px solid #d8dbe0;
  background: #f0f3f5;
  font-size: 11px;
  font-weight: 600;
  color: #5c6873;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.config-tabela__nao-informado {
  white-space: nowrap;
  color: #9da5b1;
  font-style: italic;
}

.config-tabela td.cobrancas-grupo__codigo {
  font-weight: 600;
  color: #5c6873;
}

.cobrancas-grupo__codigo {
  width: 90px;
}

.config-auto-label {
  font-size: 11px;
  margin-left: 4px;
}

.tab-badge-pendente {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  border-radius: 9px;
  background-color: #e55353;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  padding: 0 4px;
  margin-left: 5px;
  vertical-align: middle;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>

<style>
.modalbox .form-group label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.modalbox .form-control {
  font-size: 13px;
}

.modalbox .message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}
</style>
